module.exports = __webpack_public_path__ + "static/media/DSC_0828.cc102ae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0828.jpg
// module id = 704
// module chunks = 0